<template>
    <div>
        <div id="header-container" class="px-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <div class="p-2 mb-4">
                                <enterprises-china v-if="$route.query.bank_account == 'enterprise' && $route.query.account_type == 'china'"></enterprises-china>
                                <enterprises-hongkong v-else-if="$route.query.bank_account == 'enterprise' && $route.query.account_type == 'hongkong'"></enterprises-hongkong>
                                <international v-else-if="$route.query.bank_account == 'international' && $route.query.account_type == 'international'"></international>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import enterprisesChina from "@/components/CardManagement/enterprisesChina";
    import enterprisesHongkong from "@/components/CardManagement/enterprisesHongkong";
    import international from "@/components/CardManagement/international";
  
    export default {
        name: 'account-opening',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                stepList:["Select Bank Account","Account Type", "Information"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            enterprisesChina,
            enterprisesHongkong,
            international
        },
        methods:{
            
        },
        mounted(){
            
        }
    };
  </script>
